import {RestResource} from '@/api/rest'
import {athubAxios} from '@/util'
import {EQUIPMENT_IN_OUT_SERVER} from "@/api";

const registerRecord = new RestResource({server: EQUIPMENT_IN_OUT_SERVER, resource: 'registerRecord'});

registerRecord.realTimeRegisterrecord = (deptId) => {
    let url = `${EQUIPMENT_IN_OUT_SERVER}/realTimeRegisterrecord/deptid/${deptId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, {}).then(responseBody => {
            if (String(responseBody.data.code) === '200') {
                resolve(responseBody.data.result);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

registerRecord.abnormalRecords = (deptId, startDate, endDate) => {
    let url = `${EQUIPMENT_IN_OUT_SERVER}/abnormal/deptid/${deptId}/startDate/${startDate}/endDate/${endDate}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, {}).then(responseBody => {
            if (String(responseBody.data.code) === '200') {
                resolve(responseBody.data.result);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

registerRecord.all = (data) => {
    return athubAxios.post(`${EQUIPMENT_IN_OUT_SERVER}/registerrecord/all`, data);
};

registerRecord.fetchRealtimeTrend = (deptIds) => {
    let url = `${EQUIPMENT_IN_OUT_SERVER}/realtimetrend`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, {'deptidlist': deptIds}).then(responseBody => {
            if (String(responseBody.data.code) === '200') {
                resolve(responseBody.data.result);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

export default registerRecord;
